<template>
  <div v-if="showSupportOptions">
    <v-layout id="support">
      <v-flex xs12 id="support-container">

        <div id="powered-container">
          <span @click="safetyPage()">
            <img src="@/assets/powered-safety.svg" class="powered-img">
          </span>
        </div>

        <div id="support-container">

          <!-- <v-btn color="primary" class="support-btn" @click="go_to_backlog" :style="dark_t?'color:black':''">
            <fs1 tag="span">Backlog CCE/ASI</fs1>
          </v-btn> -->

          <div class="condensed-menu" @focusout="backlog_btns_focusout" tabindex="-1" ref="backlog_btns">
            <ul :class="backlog_btns && 'visible'">
              <template v-for="(item,i) in backlog_report_list">
                <li  class="backlog_btns" @click="window_open(item.link)" :key="i"  :style="dark_t?'color:black':''" color="primary">
                 <div>{{item.name}}</div>  
                </li>
            </template>
            </ul>
            <v-btn color="primary" class="support-btn" @click="backlog_btn_click" :style="dark_t?'color:black':''">
              Reportes
            </v-btn>
          </div>

          <a :href="link_aims_proc" target="_blank" style="text-decoration: none;">
            <v-btn color="" class="support-btn bg-green f-white">
              {{$t('Procedimiento AIMS')}}
            </v-btn>
          </a>

          <a :href="link_aims_policy" target="_blank" style="text-decoration: none;">
            <v-btn color="" class="support-btn bg-green f-white">
              {{$t('Política AIMS')}}
            </v-btn>
          </a>

          <v-btn color="" class="support-btn bg-darkgreen f-white" @click="standarDialog = true">
            {{$t('Estándares AIMS')}}
          </v-btn>

           <div class="condensed-menu" @focusout="support_btns_focusout" tabindex="-1" ref="support_btns">
            <ul :class="support_btns && 'visible'">
              <li @click="supportVideoVisible = true" style="background-color: #e65100;">
                <span>{{$t('Video Tutorial')}}</span>
              </li>
              <li @click="supportFormVisible = true" style="background-color: #2196f3;">
                <span>{{$t('Escríbenos')}}</span>
              </li>
              <li @click="supportPhoneVisible = true" style="background-color: #fb8c00;">
                <span>{{$t('Llámanos')}}</span>
              </li>
            </ul>
            <v-btn large class="support-btn" @click="support_btn_click">
              <v-icon>play_arrow</v-icon>
              <v-icon>email</v-icon>
              <v-icon>phone_in_talk</v-icon>
            </v-btn>
          </div>

        </div>

      <!--Dialog teléfono-->
      <v-dialog v-model="supportPhoneVisible" width="30%">
        <v-card class="pa-40 textAlignCenter">
          <h2>
            {{$t('¿Necesitas Ayuda?')}}
          </h2>
          <br>
          <hr>
          <br>
          <!--p class="support-phone-1">+56 2 2666 5844</p-->
          <!--p class="support-phone-2">+56 9 7499 5325</p-->
          <p class="support-phone-1">+56 9 7499 5325</p>
          <hr>
          <br>
          <p class="support-text">
            {{$t('También puede comunicarse con nosotros escribiendo directamente a ')}}<b>support@safetyclub.zendesk.com</b>
          </p>
          <p class="support-text">
            <i>{{$t('Horario atención telefónica: Lunes a Viernes de 9:00 a 19:00')}}</i>
          </p>
          <div>
            <v-btn @click="supportPhoneVisible = false" color="secondary" small>
              <span>{{$t('Cerrar')}}</span>
            </v-btn>
          </div>
          <span style="float:right;">
            <a :href="publicFile1.file" target="_blank">{{publicFile1.comment}}</a>
          </span>
        </v-card>
      </v-dialog>


      <!--Dialog correo-->
      <v-dialog v-model="supportFormVisible" :width="mobil? '100%':'30%'">
        <v-card class="pa-40 textAlignCenter">
          <h2>
            {{$t('¿Necesitas Ayuda?')}}
          </h2>
          <br>
          <br>
          <form :model="form" ref="form">
            <v-text-field
              v-model="form.nombre"
              :rules="[rules.required]"
              :label="$t('Nombre Completo*')"
              required></v-text-field>
            <br>
            <v-text-field
              v-model="form.correo"
              :rules="[rules.required, rules.email]"
              :label="$t('Correo*')"
              required></v-text-field>
            <br>
            <v-text-field
              v-model="form.telefono"
              :rules="[rules.required, rules.telefono]"
              :label="$t('Teléfono*')"
              required>
              <template slot="prepend">+56</template>
            </v-text-field>  
            <br>
            <v-select
              :label="$t('Tipo de Usuario')"
              :items="bhpProfiles"
              outlined
              v-model="form.role"
              :placeholder="form.role? undefined: $t('Seleccione tipo de usuario')"
              item-value="key"
              item-text="text"
              ></v-select>
            <br>
            <v-textarea v-model="form.mensaje" :label="$t('Mensaje*')" :rules="[rules.required]"></v-textarea>
          </form>
          <p class="support-text">
            {{$t('También puede comunicarse con nosotros escribiendo directamente a ')}}
            <b>soporte@ac.bhp.lifeon.cl </b>{{$t('o llamando al')}}<b> +56 9 7499 5325</b>.
          </p>
          <p class="support-text">
            {{$t('Para descargar la Política de Asset Integrity pinche ')}}
            <a :href="publicFile1.file" target="_blank">aquí.</a>
          </p>
          <p class="support-text">
            <i>{{$t('Horario atención telefónica y chat: Lunes a Vienes de 9:00 a 18:30')}}</i>
          </p>
          <div>
            <v-btn @click="cleanForm" color="secondary" small>{{$t('Cancelar')}}</v-btn>
            <v-btn type="primary" @click="sendMail('form')" color="primary" small>{{$t('Enviar')}}</v-btn>            
          </div>
          </v-card>
      </v-dialog>


      <v-dialog v-model="supportVideoVisible">
        <v-card class="pa-40 textAlignCenter">
          <h2>
            {{$t('Como crear un activo crítico')}}
          </h2>
          <div>
            <div class="video-cont">
              <div class="resp-container">
                <iframe
                  class="resp-iframe"
                  src="https://www.youtube.com/embed/KlqNftaQjKM"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>

            <h3 class="title-download">
              {{ $t('Descargar Tutorial') }}
            </h3>

            <div class="download-box">
              <!-- <a target="_blank" href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Como_crear_un_activo_cr%C3%ADtico_SD_480.mp4">
                <div class="icon">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </div>
                <div class="text">
                  {{$t('Baja calidad')}}
                  <br>
                  <span class="mini-text">({{$t('menos peso')}})</span>
                </div>
              </a>
              <a target="_blank"
                href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Como_crear_un_activo_cr%C3%ADtico_HD_1080.mp4">
                  <div class="icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Alta calidad')}}
                    <br>
                    <span class="mini-text">({{$t('más peso')}})</span>
                  </div>
              </a> -->
            </div>
          </div>
          <br>

          <h2>
            {{$t('Como crear un repuesto crítico')}}
          </h2>
          <div>
            <div class="video-cont">
              <div class="resp-container">
                <iframe
                  class="resp-iframe"
                  src="https://www.youtube.com/embed/B9febhB6dc0"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>

            <h3 class="title-download">
              {{ $t('Descargar Tutorial') }}
            </h3>

            <div class="download-box">
              <!-- <a target="_blank" href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Como_crear_un_repuesto_cr%C3%ADtico_SD_480.mp4">
                <div class="icon">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </div>
                <div class="text">
                  {{$t('Baja calidad')}}
                  <br>
                  <span class="mini-text">({{$t('menos peso')}})</span>
                </div>
              </a>
              <a target="_blank"
                href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Como_crear_un_repuesto_cr%C3%ADtico_HD_1080.mp4">
                  <div class="icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Alta calidad')}}
                    <br>
                    <span class="mini-text">({{$t('más peso')}})</span>
                  </div>
              </a> -->
            </div>
          </div>
          <br>

          <h2>
            {{$t('Como revisar un activo o repuesto crítico')}}
          </h2>
          <div>
            <div class="video-cont">
              <div class="resp-container">
                <iframe
                  class="resp-iframe"
                  src="https://www.youtube.com/embed/ZpWE6EnweKs"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>

            <h3 class="title-download">
              {{ $t('Descargar Tutorial') }}
            </h3>

            <div class="download-box">
              <a target="_blank" href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Como_revisar_un_activo_o_repuesto_critico_SD_480.mp4">
                <div class="icon">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </div>
                <div class="text">
                  {{$t('Baja calidad')}}
                  <br>
                  <span class="mini-text">({{$t('menos peso')}})</span>
                </div>
              </a>
              <a target="_blank"
                href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Como_revisar_un_activo_o_repuesto_critico_HD_1080.mp4">
                  <div class="icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Alta calidad')}}
                    <br>
                    <span class="mini-text">({{$t('más peso')}})</span>
                  </div>
              </a>
            </div>
          </div>
          <br>

          <h2>
            {{$t('Como utilizar el dashboard')}}
          </h2>
          <div>
            <div class="video-cont">
              <div class="resp-container">
                <iframe
                  class="resp-iframe"
                  src="https://www.youtube.com/embed/l-T4CNlxPMY"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>

            <h3 class="title-download">
              {{ $t('Descargar Tutorial') }}
            </h3>

            <div class="download-box">
              <!-- <a target="_blank" href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Como_utilizar_el_dashboard_SD_480.mp4">
                <div class="icon">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </div>
                <div class="text">
                  {{$t('Baja calidad')}}
                  <br>
                  <span class="mini-text">({{$t('menos peso')}})</span>
                </div>
              </a>
              <a target="_blank"
                href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Como_utilizar_el_dashboard_HD_1080.mp4">
                  <div class="icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Alta calidad')}}
                    <br>
                    <span class="mini-text">({{$t('más peso')}})</span>
                  </div>
              </a> -->
            </div>
          </div>
          <br>

          <h2>
            {{$t('Usuario modelo operativo')}}
          </h2>
          <div>
            <div class="video-cont">
              <div class="resp-container">
                <iframe
                  class="resp-iframe"
                  src="https://www.youtube.com/embed/FM70Ck4tEQw"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen/>
              </div>
            </div>

            <h3 class="title-download">
              {{ $t('Descargar Tutorial') }}
            </h3>

            <div class="download-box">
              <a target="_blank" href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Usuario_modelo_operativo_SD_480.mp4">
                <div class="icon">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </div>
                <div class="text">
                  {{$t('Baja calidad')}}
                  <br>
                  <span class="mini-text">({{$t('menos peso')}})</span>
                </div>
              </a>
              <a target="_blank"
                href="http://public-files.ac.dev.bhp.lifeon.cl/uploads/Usuario_modelo_operativo_HD_1080.mp4">
                  <div class="icon">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                  </div>
                  <div class="text">
                    {{$t('Alta calidad')}}
                    <br>
                    <span class="mini-text">({{$t('más peso')}})</span>
                  </div>
              </a>
            </div>
          </div>
          <br>



          <div>
            <v-btn color="secondary" @click="supportVideoVisible = false" small>{{ $t('Cerrar') }}</v-btn>
          </div>
          <span style="float:right;">
            <a :href="publicFile1.file" target="_blank">{{publicFile1.comment}}</a>
          </span>
          </v-card>
      </v-dialog>

      <v-dialog v-model="standarDialog" width="1200px">
        <v-card class="pa-40 textAlignCenter">
          <h3>Estándares</h3>
          <br>
          <StTable :rows.sync="standards" :readOnly="true"/>
          <br>
          <div>
            <v-btn @click="standarDialog = false" color="secondary" small>
              <span>{{$t('Cerrar')}}</span>
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import StTable from '@/components/admin/tables/Standars.vue';
import { sendMailSoporte } from '@/requests/ac';
import { mapGetters } from 'vuex';

const validateMail = value => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(value)
};

const validateTelefono = value => !!parseInt(value) && value.length === 9;

export default {
  components: {StTable},
  name: 'supportFooter',
  computed: {
    ...mapGetters({
      /* isLoggedIn: 'isLoggedIn', */
      user: 'user',
      /* role: 'role', */
      session: 'session',
      publicFile1: 'publicFile1',
      standards: 'standards',
      aims_policy:'aims_policy'
    }),
    aims_policy_o(){ return (this.aims_policy||{}).results||[] },
    link_aims_policy(){ return (this.aims_policy_o.find(f=>f.id===1)||{}).link},
    link_aims_proc(){ return (this.aims_policy_o.find(f=>f.id===2)||{}).link},
  },
  data() {
    return {
      backlog_report_list:[],
      backlog_btns:false,
      support_btns:false,
      link:null,
      standarDialog: false,
      showSupportOptions: false,
      supportVideoVisible: false,
      supportFormVisible: false,
      supportPhoneVisible: false,
      creator: false,
      reviewer: false,
      admin: false,
      bhpProfiles: [
        {key: 'hse', text: 'HSE'},
        {key: 'health', text: this.$t('Especialista de Salud')},
        {key: 'safety', text: this.$t('Especialista de Seguridad')},
        {key: 'environment', text: this.$t('Especialista de Medioambiente')},
        {key: 'contractor_hse', text: this.$t('HSE Contratista')},
        {key: 'owner', text: this.$t('Dueño de Contrato')},
        {key: 'contract_owner', text: this.$t('Dueño de Contrato')},
        {key: 'risk', text: this.$t('Especialista de Riesgo')},
        {key: 'administrator', text: this.$t('Administrador de Contrato')},
        {key: 'contractor_coordinator', text: this.$t('Coordinador Contratista')},
        {key: 'coordinator', text: this.$t('Coordinador')},
        {key: 'manager', text: this.$t('Gerente de Área')},
        {key: 'super', text: this.$t('Superintendente de Área')},
        {key: 'general_manager', text: this.$t('Gerente General')},
      ],
      form: {
        nombre: '',
        correo: '',
        telefono: '',
        perfil: '',
        mensaje: '',
      },
      rules: {
        required: value => !!value || 'Requerido.',
        // counter: value => value.length <= 20 || 'Max 20 characters',
        telefono: value => validateTelefono(value) || 'Error formato teléfono: 9 números',
        email: value => validateMail(value) || 'e-mail no valido.',
      }
    };
  },
  created() {
    
		this.requests.gets['dashboard/backlog_report_list/a/no_paginated/all']()
			.then(r => r && r.length && (this.backlog_report_list = r))


		this.requests.get['dashboard/backlog_report']()
			.then(r => {
				if (r.link)this.link = r.link;
			})
    // CHAT
    this.setShowSupportOptions();
    // ZendeskChat
    window.zESettings = {
      webWidget: {
        offset: {
          horizontal: '0px',
          vertical: '0px',
        },
        chat: {
          suppress: false,
        },
        talk: {
          suppress: false,
        },
        helpCenter: {
          suppress: false,
        },
        contactForm: {
          suppress: true,
        },
      },
    };
  },
  watch: {
    /* isLoggedIn() {
      this.setShowSupportOptions();
    }, */
    showSupportOptions() {
      if (window.zE) {
        this.showSupportOptions ? window.zE.show && window.zE.show() : window.zE.hide();
      } else if (this.showSupportOptions) {
        // Start of safetyclub Zendesk Widget script
        window.zE || (function (e, t, s) {
          var n = window.zE = window.zEmbed = function () {
            n._.push(arguments);
          };
          const a = n.s = e.createElement(t);
          const r = e.getElementsByTagName(t)[0];
          n.set = function (e) {
            n.set._.push(e);
          };
          n._ = [];
          n.set._ = [];
          a.async = true;
          a.setAttribute('charset', 'utf-8');
          a.src = `https://static.zdassets.com/ekr/asset_composer.js?key=${s}`;
          n.t = +new Date();
          a.type = 'text/javascript';
          r.parentNode.insertBefore(a, r);
        }(document, 'script', 'cd9487bd-3ef3-4a2c-8bcc-1d563414092d'));
      }
    },
  },
  methods: {
    window_open(link){window.open(link)},
    backlog_btns_focusout(){ this.backlog_btns = false},
    support_btns_focusout(){this.support_btns = false;},
    support_btn_click(){
      this.support_btns=true
      this.$refs.support_btns.focus();
    },
    backlog_btn_click(){
      this.backlog_btns=true;
      this.$refs.backlog_btns.focus();
    },
    
    $t(t) { return t },
    setShowSupportOptions() {
      this.showSupportOptions = true// this.isLoggedIn;
    },
    validate() {
      const snack = (msj) =>  this.setSnackbar({message:msj, class: 'warning'});
      let ok = true;
      const invalid = () => ok = false;
      if (!this.form.nombre) snack('Falta nombre') || invalid();
      if (!this.form.mensaje) snack('Falta mensaje') || invalid();
      if (!validateMail(this.form.correo)) snack('Email no valido') || invalid();
      if (!validateTelefono(this.form.telefono)) snack('Error formato teléfono: 9 números') || invalid();
      return ok
    },
    sendMail(formName) {
        if (this.validate()) {
          this.setProgress({mensaje:'enviado...',show:true});


          sendMailSoporte(this.session, this.form)
            .then((response) => {
              this.setProgress({show:false});
              this.setSnackbar({message:'Correo enviado exitosamente.', class: 'success'});
              this.cleanForm();
            })
            .catch((e) => this.getError(e));
        }
     
    },
    cleanForm() {
      this.form.nombre = '';
      this.form.correo = '';
      this.form.telefono = '';
      this.form.role = '';
      this.form.mensaje = '';

      this.supportFormVisible = false;
    },
		go_to_backlog(){
			window.open(this.link, '_blank').focus();
		}
  },
};
</script>

<style scoped>
.condensed-menu{
  display: inline-block;
  height: 47px;
  border-radius: 999rem;
}
.condensed-menu>ul{
  position: fixed;
  bottom: 70px;
  /* right: 175px; */
  padding-left: 5px;
  z-index: 999;
  display: none;
  list-style: none;
}
.condensed-menu>ul.visible {
  display: inherit;
}
.condensed-menu/* :hover */>ul>li{
  cursor: pointer;
  margin:3px;
  color:white;
  border-radius: 30px;
  padding: 7px;
  padding-left: 15px;
  padding-right: 15px;
}
.backlog_btns{
  background-color: darkorange;
}
.f-white{
  color: white;
}
.bg-darkgreen{ background-color: darkgreen !important; }
.bg-green{ background-color: green !important; }
.download-box { margin-bottom: 70px; }
.download-box a {
  text-decoration: none;
  text-align: center;
  float: left;
  width: 50%;
  color: rgb(246, 123, 47);
}
.download-box .icon {
  font-size: 30px;
  margin-bottom: 10px;
}
.download-box .mini-text { font-size: 11px; }
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.resp-container {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
}
.video-cont {
  max-width: 600px;
  text-align: center;
  margin: 0 auto;
}
.title-download {
  margin-top: 30px;
  text-align: center;
}
#support { margin-top: 80px; }
#Embed { display: none; }
#support-container {
  position: fixed;
  bottom: 10px;
  right: 150px;
  z-index: 999;
}
#powered-container {
  position: fixed;
  bottom: 10px;
  left: 150px;
  z-index: 999;
}
[class*=" el-icon-"], [class^=el-icon-] {
  font-weight: bold;
}

.support-btn {
  height: 47px;
  border-radius: 999rem;
}
.support-text { text-align: center; }
.support-phone-1 {
  text-align: center;
  font-size: 3em;
}
.support-phone-2 {
  text-align: center;
  font-size: 2em;
}
.powered-img {
  height: 16px;
}
.text-tutorial {
  font-size: 18px;
}
</style>
